<template>
  <div class="box">
    <div class="user-img">
      <img :src="data.avatar || UserImgDefault" alt="">
    </div>
    <div class="user-name">
      <div class="name">昵称：{{data.username || data.name}}</div>
      <div class="title" v-if="data.point < 22">
        <span class="point-box">积分：{{data.point}}</span>
        <img src="../../assets/user/icon_level1@2x.png" alt="">
        <span>子爵</span>
      </div>
      <div class="title" v-if="data.point > 21 && data.point < 44">
        <span class="point-box">积分：{{data.point}}</span>
        <img src="../../assets/user/bojue.png" alt="">
        <span>伯爵</span>
      </div>
      <div class="title" v-if="data.point > 43 && data.point < 88">
        <span class="point-box">积分：{{data.point}}</span>
        <img src="../../assets/user/houjue.png" alt="">
        <span>侯爵</span>
      </div>
      <div class="title" v-if="data.point > 87">
        <span class="point-box">积分：{{data.point}}</span>
        <img src="../../assets/user/gongjue.png" alt="">
        <span>公爵</span>
      </div>
    </div>
    <div class="back" @click="$router.push({path: '/user/info'})">
      <img src="../../assets/user/back.png" alt="">
    </div>
  </div>
</template>

<script>
import UserImgDefault from '../../assets/user/icon_face_default22@2x.png'
export default {
  name: "UserContentHeader",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      UserImgDefault: UserImgDefault
    }
  }
}
</script>

<style lang="scss" scoped>
.back {
  position: absolute;
  right: 25px;

  img {
    width: 80px;
  }
}

.user-img {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  //width: 120px;
  //height: 120px;
  margin-left: 25px;
  img {
    border: 4px solid #0090C5;
    width: 120px;
    height: 120px;
    border-radius: 50%;
  }
}

.user-name {
  margin-left: 30px;

  .point-box {
    margin-right: 10px;
  }

  .name {
    margin-bottom: 16px;
    font-size: 28px;
    color: #ffffff;
    font-weight: 600;
    text-align: left;
  }

  .title {
    display: flex;
    align-items: center;

    img {
      margin-right: 12px;
      width: 36px;
    }

    span {
      font-size: 24px;
      color: #ffffff;
    }
  }
}

.box {
  position: relative;
  width: 100%;
  height: 240px;
  background: url("../../assets/user/bgcolor@2x.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}
</style>
